<template>
  <v-dialog v-model="dialogOpen" width="450" persistent>
    <v-card :disabled="telcoProvisioningLoading">
      <v-card-title>Edit Modem Credentials</v-card-title>

      <v-card-text>
        <v-text-field v-model="username" outlined dense label="Username"></v-text-field>
        <v-text-field v-model="password" outlined dense label="Password"></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="telcoProvisioningLoading" :loading="telcoProvisioningLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    props: ['dialogOpen'],
    
    data() {
      return {
        username: '',
        password: ''
      }
    },

    watch: {
      dialogOpen(val) {
        if(val){
          this.username = this.getTelcoProvisioning.modem_username;
          this.password = this.getTelcoProvisioning.modem_password;
        }
      }
    },

    computed: {
      ...mapState('globals', ['selectedAddress']),
      ...mapState('products', ['currentProduct']),
      ...mapState('productTelco', ['telcoProvisioningLoading']),
      ...mapGetters('productTelco',['getTelcoProvisioning'])
    },

    methods: {
      ...mapActions('productTelco',['updateTelcoProvisioning']),
      async submit(){
        try{
          await this.updateTelcoProvisioning({pid:this.currentProduct.id,data:{modem_username: this.username, modem_password: this.password}});
          this.closeDialog();
        }catch(err){}
      },
      closeDialog(){ this.$emit('close-dialog'); }
    },
  }
</script>

<style lang="scss" scoped>

</style>
